import { IOnboardingState } from "@edp-store/state/onboarding.state";
import { createSelector } from "@ngrx/store";
import { IAppState } from "../state/app.state";

const onboardingSelector = (state: IAppState) => state.onboarding;

export const getOnboarding = createSelector(onboardingSelector, (state: IOnboardingState) => state.onboarding);
export const getOnboardingWhatsNew = createSelector(onboardingSelector, (state: IOnboardingState) => state.onboardingWhatsNew);
export const getWhatsNewlastAPIError = createSelector(onboardingSelector, (state: IOnboardingState) => state.whatsNewlastAPIError);

